export enum SURVEY_STATUS {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
}
